import {obfuscate} from 'base/scripts/obfuscation.js';
import {navigate} from 'base/scripts/navigation.js';
import Swiper from 'swiper';
import { Navigation, Pagination, Scrollbar } from 'swiper/modules';

obfuscate();
navigate();

window.addEventListener('DOMContentLoaded', () => {
    /** Ouvrir/fermer les questions de la FAQ */
    const faqItems = document.querySelectorAll(".faq-item");
    faqItems.forEach((event) => {
        event.addEventListener("click", () => {
            const isCurrentlyActive = event.classList.contains('active');

            faqItems.forEach((faqItem) => {
                faqItem.classList.remove('active');
            });

            if (!isCurrentlyActive) {
                event.classList.add('active');
            }
        });
    });
});

const partnersSlider = new Swiper('.partners-slider', {
    direction: 'horizontal',
    loop: true,
    slidesPerView: 2,
    modules: [Navigation, Pagination],
    pagination: {
        el: '.swiper-pagination',
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        576: {
            slidesPerView: 3
        },
        768: {
            slidesPerView: 4
        }
    }
});

const projectStepsSlider = new Swiper('.project-steps-slider', {
    direction: 'horizontal',
    loop: false,
    slidesPerView: 1,
    modules: [Scrollbar],
    scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
    },
    breakpoints: {
        576: {
            slidesPerView: 2
        },
        992: {
            slidesPerView: 3
        },
        1400: {
            slidesPerView: 5
        }
    }
});

ShowhideHeaderOnScroll();

function ShowhideHeaderOnScroll() {
    let prevScrollpos = window.scrollY;
    const header = document.querySelector("#main-header");

    window.onscroll = function() {
        const currentScrollPos = window.scrollY;

        // Si on a scrollé à moins de 100px ou si on scroll vers le haut
        if (currentScrollPos <= 100 || prevScrollpos > currentScrollPos) {
            header.classList.remove('hidden');
        }
        // Si on scroll vers le bas
        else {
            header.classList.add('hidden');
        }

        prevScrollpos = currentScrollPos;
    }
}
